// @flow

import { type OpenedIncomingPayment, type CheckoutPaymentOptionsV2 } from './types';
import { type CheckoutPaymentOptions } from './checkout-payment-options';

export function getCheckoutPaymentOptions(incomingPayment: OpenedIncomingPayment): ?CheckoutPaymentOptions {
  return incomingPayment.checkout_payment_options;
}

export function getSafeCheckoutPaymentOptions(incomingPayment: OpenedIncomingPayment): CheckoutPaymentOptions | CheckoutPaymentOptionsV2 {
  let checkoutPaymentOptions = getCheckoutPaymentOptionsV2(incomingPayment);
  if (checkoutPaymentOptions) {
    return checkoutPaymentOptions;
  }

  checkoutPaymentOptions = getCheckoutPaymentOptions(incomingPayment);

  if (!checkoutPaymentOptions) {
    throw new Error('checkoutPaymentOptions is not defined');
  }

  return checkoutPaymentOptions;
}

export function getCheckoutPaymentOptionsV2(incomingPayment: OpenedIncomingPayment): ?CheckoutPaymentOptionsV2 {
  if (incomingPayment.v2 && incomingPayment.v2.checkout_payment_options) {
    return incomingPayment.v2.checkout_payment_options;
  }

  return null;
}

export function getSafeCheckoutPaymentOptionsV2(incomingPayment: OpenedIncomingPayment): CheckoutPaymentOptionsV2 {
  const checkoutPaymentOptions = getCheckoutPaymentOptionsV2(incomingPayment);

  if (!checkoutPaymentOptions) {
    throw new Error('checkoutPaymentOptions V2 is not defined');
  }

  return checkoutPaymentOptions;
}
